import { createFeatureSelector, createSelector } from "@ngrx/store";
import { chartsSettingFeatureKey } from "./charts-setting.reducer";

export const selectChartsSettingState = createFeatureSelector(chartsSettingFeatureKey);

export const selectChartsSetting = createSelector(
  selectChartsSettingState,
  (state: any) => state
);